import React, { ReactNode } from 'react';

import { colors } from '@nerdwallet/base-styles/variables';

import styles from './dashboard-footer.module.scss';

type DashboardFooterProps = {
  backgroundColor?: string;
  children: ReactNode;
};

const DashboardFooter = ({
  backgroundColor = colors.white,
  children,
}: DashboardFooterProps): JSX.Element => {
  return (
    <div className={styles.footer} style={{ backgroundColor }}>
      {children}
    </div>
  );
};

export default DashboardFooter;
